import React from "react";
import { Helmet } from "react-helmet";

import AboutUs from "../../containers/About/AboutUs";
import { MainContainer } from "../../helpers/StyledComponents";

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      <MainContainer>
        <AboutUs />
      </MainContainer>
    </>
  );
};

export default About;
